var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/data/index_sponsor": "6882",
	"./assets/data/index_sponsor.yaml": "6882",
	"./assets/data/judge": "5155",
	"./assets/data/judge.yaml": "5155",
	"./assets/data/nominee_en": "9a18",
	"./assets/data/nominee_en.yaml": "9a18",
	"./assets/data/nominee_tw": "9d9b",
	"./assets/data/nominee_tw.yaml": "9d9b",
	"./assets/data/recommend_en": "d50a",
	"./assets/data/recommend_en.yaml": "d50a",
	"./assets/data/recommend_tw": "5060",
	"./assets/data/recommend_tw.yaml": "5060",
	"./assets/data/video_en": "d713",
	"./assets/data/video_en.yaml": "d713",
	"./assets/data/video_tw": "502f",
	"./assets/data/video_tw.yaml": "502f",
	"./assets/fontawesome": "9ca4",
	"./assets/fontawesome.js": "9ca4",
	"./assets/images/archive/archive_1.png": "28c8",
	"./assets/images/archive/archive_2.png": "e91a",
	"./assets/images/archive/archive_3.png": "d103",
	"./assets/images/archive/archive_4.png": "737c",
	"./assets/images/archive/archive_5.png": "e063",
	"./assets/images/archive/archive_6.png": "c355",
	"./assets/images/archive/archive_7.png": "df74",
	"./assets/images/archive/archive_8.png": "9da7",
	"./assets/images/archive/archive_9.png": "0fa6",
	"./assets/images/background.png": "9855",
	"./assets/images/banner_1.jpg": "bb5c",
	"./assets/images/banner_2.jpg": "aa40",
	"./assets/images/banner_3.jpg": "471f",
	"./assets/images/banner_half.jpg": "0588",
	"./assets/images/bg_long.png": "490e",
	"./assets/images/demo.jpg": "34b4",
	"./assets/images/faq/campaign.png": "4682",
	"./assets/images/faq/ott_1.png": "bc54",
	"./assets/images/faq/ott_2.png": "a1bf",
	"./assets/images/faq/ott_3.png": "c377",
	"./assets/images/faq/ott_4.png": "b382",
	"./assets/images/faq/ott_5.png": "fbe6",
	"./assets/images/faq/ott_6.png": "361c",
	"./assets/images/film_photo/nominee/1/1.jpg": "853a",
	"./assets/images/film_photo/nominee/1/2.jpg": "0f68",
	"./assets/images/film_photo/nominee/1/3.jpg": "0177",
	"./assets/images/film_photo/nominee/1/4.jpg": "598a",
	"./assets/images/film_photo/nominee/1/5.jpg": "d583",
	"./assets/images/film_photo/nominee/10/1.jpg": "9273",
	"./assets/images/film_photo/nominee/10/2.jpg": "ef44",
	"./assets/images/film_photo/nominee/10/3.jpg": "5779",
	"./assets/images/film_photo/nominee/10/4.jpg": "21ff",
	"./assets/images/film_photo/nominee/10/5.jpg": "4d6a",
	"./assets/images/film_photo/nominee/11/1.jpg": "9ce7",
	"./assets/images/film_photo/nominee/11/2.jpg": "2701",
	"./assets/images/film_photo/nominee/11/3.jpg": "554f",
	"./assets/images/film_photo/nominee/11/4.jpg": "d6f8",
	"./assets/images/film_photo/nominee/11/5.jpg": "b58e",
	"./assets/images/film_photo/nominee/12/1.jpg": "0f95",
	"./assets/images/film_photo/nominee/12/2.jpg": "c016",
	"./assets/images/film_photo/nominee/12/3.jpg": "7ad7",
	"./assets/images/film_photo/nominee/12/4.jpg": "9e9a",
	"./assets/images/film_photo/nominee/12/5.jpg": "bfad",
	"./assets/images/film_photo/nominee/13/1.jpg": "5040",
	"./assets/images/film_photo/nominee/13/2.jpg": "93fb",
	"./assets/images/film_photo/nominee/13/3.jpg": "32a0",
	"./assets/images/film_photo/nominee/13/4.jpg": "d345",
	"./assets/images/film_photo/nominee/13/5.jpg": "5e9a",
	"./assets/images/film_photo/nominee/14/1.jpg": "13fd",
	"./assets/images/film_photo/nominee/14/2.jpg": "3f29",
	"./assets/images/film_photo/nominee/14/3.jpg": "b31a",
	"./assets/images/film_photo/nominee/14/4.jpg": "e040",
	"./assets/images/film_photo/nominee/14/5.jpg": "990a",
	"./assets/images/film_photo/nominee/15/1.jpg": "2d4a",
	"./assets/images/film_photo/nominee/15/2.jpg": "5308",
	"./assets/images/film_photo/nominee/15/3.jpg": "be09",
	"./assets/images/film_photo/nominee/15/4.jpg": "f2f1",
	"./assets/images/film_photo/nominee/16/1.jpg": "04f6",
	"./assets/images/film_photo/nominee/16/2.jpg": "f84d",
	"./assets/images/film_photo/nominee/16/3.jpg": "7ab1",
	"./assets/images/film_photo/nominee/17/1.jpg": "81f9",
	"./assets/images/film_photo/nominee/17/2.jpg": "9b1d",
	"./assets/images/film_photo/nominee/17/3.jpg": "e012",
	"./assets/images/film_photo/nominee/17/4.jpg": "3258",
	"./assets/images/film_photo/nominee/17/5.jpg": "997b",
	"./assets/images/film_photo/nominee/18/1.jpg": "d4d5",
	"./assets/images/film_photo/nominee/18/2.jpg": "9311",
	"./assets/images/film_photo/nominee/18/3.jpg": "79f1",
	"./assets/images/film_photo/nominee/18/4.jpg": "c5aa",
	"./assets/images/film_photo/nominee/18/5.jpg": "d220",
	"./assets/images/film_photo/nominee/19/1.jpg": "cdb5",
	"./assets/images/film_photo/nominee/19/2.jpg": "4576",
	"./assets/images/film_photo/nominee/19/3.jpg": "72b1",
	"./assets/images/film_photo/nominee/19/4.jpg": "eefc",
	"./assets/images/film_photo/nominee/19/5.jpg": "f161",
	"./assets/images/film_photo/nominee/2/1.jpg": "6775",
	"./assets/images/film_photo/nominee/2/2.jpg": "2ba5",
	"./assets/images/film_photo/nominee/2/3.jpg": "a6e2",
	"./assets/images/film_photo/nominee/2/4.jpg": "47ac",
	"./assets/images/film_photo/nominee/2/5.jpg": "e550",
	"./assets/images/film_photo/nominee/20/1.jpg": "7f98",
	"./assets/images/film_photo/nominee/20/2.jpg": "3f99",
	"./assets/images/film_photo/nominee/20/3.jpg": "8bd5",
	"./assets/images/film_photo/nominee/20/4.jpg": "830d",
	"./assets/images/film_photo/nominee/20/5.jpg": "e198",
	"./assets/images/film_photo/nominee/21/1.jpg": "a31b",
	"./assets/images/film_photo/nominee/21/2.jpg": "ca8b",
	"./assets/images/film_photo/nominee/21/3.jpg": "58f9",
	"./assets/images/film_photo/nominee/21/4.jpg": "5e1a",
	"./assets/images/film_photo/nominee/21/5.jpg": "88d1",
	"./assets/images/film_photo/nominee/22/1.jpg": "0fc2",
	"./assets/images/film_photo/nominee/22/2.jpg": "084f",
	"./assets/images/film_photo/nominee/22/3.jpg": "d23c",
	"./assets/images/film_photo/nominee/22/4.jpg": "e90b",
	"./assets/images/film_photo/nominee/22/5.jpg": "ad4f",
	"./assets/images/film_photo/nominee/23/1.jpg": "4b65",
	"./assets/images/film_photo/nominee/23/2.jpg": "e8a5",
	"./assets/images/film_photo/nominee/23/3.jpg": "110e",
	"./assets/images/film_photo/nominee/24/1.jpg": "6f7c",
	"./assets/images/film_photo/nominee/24/2.jpg": "b1f4",
	"./assets/images/film_photo/nominee/24/3.jpg": "380a",
	"./assets/images/film_photo/nominee/24/4.jpg": "a76a",
	"./assets/images/film_photo/nominee/24/5.jpg": "ca0c",
	"./assets/images/film_photo/nominee/25/1.jpg": "c146",
	"./assets/images/film_photo/nominee/25/2.jpg": "8968",
	"./assets/images/film_photo/nominee/25/3.jpg": "35d7",
	"./assets/images/film_photo/nominee/26/1.jpeg": "963d",
	"./assets/images/film_photo/nominee/26/2.jpeg": "d86a",
	"./assets/images/film_photo/nominee/26/3.jpeg": "06f0",
	"./assets/images/film_photo/nominee/26/4.jpeg": "b951",
	"./assets/images/film_photo/nominee/26/5.jpeg": "fabf",
	"./assets/images/film_photo/nominee/3/1.jpg": "3efc",
	"./assets/images/film_photo/nominee/3/2.jpg": "0b15",
	"./assets/images/film_photo/nominee/3/3.jpg": "aa90",
	"./assets/images/film_photo/nominee/4/1.jpg": "43ee",
	"./assets/images/film_photo/nominee/4/2.jpg": "cb11",
	"./assets/images/film_photo/nominee/4/3.jpg": "03c5",
	"./assets/images/film_photo/nominee/5/1.jpg": "036b",
	"./assets/images/film_photo/nominee/5/2.jpg": "9429",
	"./assets/images/film_photo/nominee/5/3.jpg": "2f73",
	"./assets/images/film_photo/nominee/5/4.jpg": "6141",
	"./assets/images/film_photo/nominee/5/5.jpg": "6416",
	"./assets/images/film_photo/nominee/6/1.jpg": "dba0",
	"./assets/images/film_photo/nominee/6/2.jpg": "06e2",
	"./assets/images/film_photo/nominee/6/3.jpg": "0dfa",
	"./assets/images/film_photo/nominee/7/1.jpg": "12a0",
	"./assets/images/film_photo/nominee/7/2.jpg": "7636",
	"./assets/images/film_photo/nominee/7/3.jpg": "6600",
	"./assets/images/film_photo/nominee/7/4.jpg": "b6c6",
	"./assets/images/film_photo/nominee/7/5.jpg": "dc3c",
	"./assets/images/film_photo/nominee/8/1.jpg": "41b2",
	"./assets/images/film_photo/nominee/8/2.jpg": "b83d",
	"./assets/images/film_photo/nominee/8/3.jpg": "c972",
	"./assets/images/film_photo/nominee/8/4.jpg": "5648",
	"./assets/images/film_photo/nominee/8/5.jpg": "8c66",
	"./assets/images/film_photo/nominee/9/1.jpg": "6af6",
	"./assets/images/film_photo/nominee/9/2.jpg": "ecbe",
	"./assets/images/film_photo/nominee/9/3.jpg": "c0c9",
	"./assets/images/film_photo/nominee/9/4.jpg": "0776",
	"./assets/images/film_photo/program/0/1.jpg": "dba8",
	"./assets/images/film_photo/program/0/2.jpg": "fb1b",
	"./assets/images/film_photo/program/0/3.jpg": "9bf6",
	"./assets/images/film_photo/program/0/4.jpg": "ed4b",
	"./assets/images/film_photo/program/0/5.jpg": "c5a6",
	"./assets/images/film_photo/program/0/6.jpg": "c8d9",
	"./assets/images/film_photo/program/0/7.jpg": "7ee5",
	"./assets/images/film_photo/program/0/8.jpg": "ffbd",
	"./assets/images/film_photo/program/1/1.jpg": "f8bb",
	"./assets/images/film_photo/program/1/2.jpg": "8db5",
	"./assets/images/film_photo/program/1/3.jpg": "2748",
	"./assets/images/film_photo/program/1/4.jpg": "8486",
	"./assets/images/film_photo/program/1/5.jpg": "b872",
	"./assets/images/film_photo/program/1/6.jpg": "c27c",
	"./assets/images/film_photo/program/10/1.jpg": "22ef",
	"./assets/images/film_photo/program/10/2.jpg": "4872",
	"./assets/images/film_photo/program/10/3.jpg": "3c33",
	"./assets/images/film_photo/program/10/4.jpg": "664e",
	"./assets/images/film_photo/program/10/5.jpg": "4c48",
	"./assets/images/film_photo/program/11/1.jpg": "a50a",
	"./assets/images/film_photo/program/11/2.jpg": "2bbe",
	"./assets/images/film_photo/program/11/3.jpg": "60b2",
	"./assets/images/film_photo/program/11/4.jpg": "89cf",
	"./assets/images/film_photo/program/11/5.jpg": "b6f2",
	"./assets/images/film_photo/program/12/1.jpg": "f0ae",
	"./assets/images/film_photo/program/12/2.jpg": "a48a",
	"./assets/images/film_photo/program/12/3.jpg": "e8a4",
	"./assets/images/film_photo/program/12/4.jpg": "a165",
	"./assets/images/film_photo/program/12/5.jpg": "8782",
	"./assets/images/film_photo/program/13/1.jpg": "3016",
	"./assets/images/film_photo/program/13/2.jpg": "348e",
	"./assets/images/film_photo/program/13/3.jpg": "af9c",
	"./assets/images/film_photo/program/13/4.jpg": "1921",
	"./assets/images/film_photo/program/13/5.jpg": "d3d1",
	"./assets/images/film_photo/program/14/1.jpg": "7c54",
	"./assets/images/film_photo/program/14/2.jpg": "1d2c",
	"./assets/images/film_photo/program/14/3.jpg": "168f",
	"./assets/images/film_photo/program/14/4.jpg": "ab1f",
	"./assets/images/film_photo/program/14/5.jpg": "ab59",
	"./assets/images/film_photo/program/15/1.jpg": "23c9",
	"./assets/images/film_photo/program/15/2.jpg": "e40c",
	"./assets/images/film_photo/program/15/3.jpg": "7f69",
	"./assets/images/film_photo/program/16/1.jpg": "c0fa",
	"./assets/images/film_photo/program/16/2.jpg": "a8b3",
	"./assets/images/film_photo/program/16/3.jpg": "bd2d",
	"./assets/images/film_photo/program/16/4.jpg": "3848",
	"./assets/images/film_photo/program/17/1.jpg": "094a",
	"./assets/images/film_photo/program/17/2.jpg": "b9d1",
	"./assets/images/film_photo/program/17/3.jpg": "8005",
	"./assets/images/film_photo/program/17/4.jpg": "c487",
	"./assets/images/film_photo/program/18/1.jpg": "e254",
	"./assets/images/film_photo/program/18/2.jpg": "c0e7",
	"./assets/images/film_photo/program/18/3.jpg": "c28a",
	"./assets/images/film_photo/program/19/1.jpg": "d7d6",
	"./assets/images/film_photo/program/19/2.jpg": "0e29",
	"./assets/images/film_photo/program/19/3.jpg": "33ea",
	"./assets/images/film_photo/program/19/4.jpg": "0471",
	"./assets/images/film_photo/program/19/5.jpg": "a183",
	"./assets/images/film_photo/program/19/6.jpg": "bfd5",
	"./assets/images/film_photo/program/19/7.jpg": "1017",
	"./assets/images/film_photo/program/19/8.jpg": "1ed7",
	"./assets/images/film_photo/program/2/1.jpg": "0c86",
	"./assets/images/film_photo/program/2/2.jpg": "5e46",
	"./assets/images/film_photo/program/2/3.jpg": "18ef",
	"./assets/images/film_photo/program/2/4.jpg": "f576",
	"./assets/images/film_photo/program/2/5.jpg": "6f83",
	"./assets/images/film_photo/program/20/1.jpg": "2c82",
	"./assets/images/film_photo/program/20/2.jpg": "5868",
	"./assets/images/film_photo/program/20/3.jpg": "fa42",
	"./assets/images/film_photo/program/20/4.jpg": "7191",
	"./assets/images/film_photo/program/20/5.jpg": "430e",
	"./assets/images/film_photo/program/21/1.jpg": "3c3d",
	"./assets/images/film_photo/program/21/2.jpg": "8b3b",
	"./assets/images/film_photo/program/21/3.jpg": "fee6",
	"./assets/images/film_photo/program/21/4.jpg": "dee6",
	"./assets/images/film_photo/program/21/5.jpg": "6037",
	"./assets/images/film_photo/program/22/1.jpg": "b77f",
	"./assets/images/film_photo/program/22/2.jpg": "f0ca",
	"./assets/images/film_photo/program/22/3.jpg": "0257",
	"./assets/images/film_photo/program/22/4.jpg": "aab8",
	"./assets/images/film_photo/program/22/5.jpg": "4260",
	"./assets/images/film_photo/program/22/6.jpg": "017f",
	"./assets/images/film_photo/program/22/7.jpg": "8cf8",
	"./assets/images/film_photo/program/23/1.png": "b938",
	"./assets/images/film_photo/program/23/2.png": "b7a3",
	"./assets/images/film_photo/program/23/3.png": "123e",
	"./assets/images/film_photo/program/23/4.png": "70c9",
	"./assets/images/film_photo/program/23/5.png": "5ca0",
	"./assets/images/film_photo/program/23/6.png": "15f5",
	"./assets/images/film_photo/program/23/7.png": "d9a3",
	"./assets/images/film_photo/program/23/8.png": "6bc0",
	"./assets/images/film_photo/program/24/1.jpg": "1945",
	"./assets/images/film_photo/program/24/2.jpg": "ddd9",
	"./assets/images/film_photo/program/24/3.jpg": "5ad5",
	"./assets/images/film_photo/program/24/4.jpg": "fd87",
	"./assets/images/film_photo/program/24/5.jpg": "1bc8",
	"./assets/images/film_photo/program/25/1.jpg": "6ad7",
	"./assets/images/film_photo/program/25/2.jpg": "dfd6",
	"./assets/images/film_photo/program/25/3.png": "634e",
	"./assets/images/film_photo/program/25/4.jpg": "4400",
	"./assets/images/film_photo/program/25/5.png": "b2b8",
	"./assets/images/film_photo/program/25/6.jpg": "746d",
	"./assets/images/film_photo/program/26/1.jpg": "a8c4",
	"./assets/images/film_photo/program/26/2.jpg": "d979",
	"./assets/images/film_photo/program/26/3.jpg": "9b66",
	"./assets/images/film_photo/program/26/4.jpg": "8ea3",
	"./assets/images/film_photo/program/26/5.jpg": "288d",
	"./assets/images/film_photo/program/27/1.jpg": "f3b0",
	"./assets/images/film_photo/program/27/2.jpg": "a873",
	"./assets/images/film_photo/program/27/3.jpg": "dc27",
	"./assets/images/film_photo/program/28/1.jpg": "16ef",
	"./assets/images/film_photo/program/28/2.jpg": "d4bf",
	"./assets/images/film_photo/program/29/1.jpg": "40ad",
	"./assets/images/film_photo/program/29/2.jpg": "577c",
	"./assets/images/film_photo/program/29/3.jpg": "1b8b",
	"./assets/images/film_photo/program/29/4.jpg": "91d1",
	"./assets/images/film_photo/program/29/5.jpg": "b256",
	"./assets/images/film_photo/program/3/1.jpg": "e451",
	"./assets/images/film_photo/program/3/10.jpg": "4ca8",
	"./assets/images/film_photo/program/3/2.jpg": "3579",
	"./assets/images/film_photo/program/3/3.jpg": "fca1",
	"./assets/images/film_photo/program/3/4.jpg": "d689",
	"./assets/images/film_photo/program/3/5.jpg": "63fc",
	"./assets/images/film_photo/program/3/6.jpg": "3513",
	"./assets/images/film_photo/program/3/7.jpg": "f129",
	"./assets/images/film_photo/program/3/8.jpg": "9b54",
	"./assets/images/film_photo/program/3/9.jpg": "a14b",
	"./assets/images/film_photo/program/30/1.jpg": "eaa8",
	"./assets/images/film_photo/program/30/2.jpg": "97f9",
	"./assets/images/film_photo/program/30/3.jpg": "0221",
	"./assets/images/film_photo/program/30/4.jpg": "59c2",
	"./assets/images/film_photo/program/31/1.jpg": "e56f",
	"./assets/images/film_photo/program/31/2.jpg": "1daf",
	"./assets/images/film_photo/program/31/3.jpg": "396d",
	"./assets/images/film_photo/program/31/4.jpg": "646f",
	"./assets/images/film_photo/program/32/1.jpg": "72a0",
	"./assets/images/film_photo/program/32/2.jpg": "9d17",
	"./assets/images/film_photo/program/32/3.jpg": "284d",
	"./assets/images/film_photo/program/32/4.jpg": "21ea",
	"./assets/images/film_photo/program/32/5.jpg": "d77e",
	"./assets/images/film_photo/program/33/1.jpg": "309e",
	"./assets/images/film_photo/program/33/2.jpg": "1c93",
	"./assets/images/film_photo/program/33/3.jpg": "e807",
	"./assets/images/film_photo/program/33/4.jpg": "4d94",
	"./assets/images/film_photo/program/33/5.jpg": "020d",
	"./assets/images/film_photo/program/34/1.jpg": "0576",
	"./assets/images/film_photo/program/34/2.jpg": "a1836",
	"./assets/images/film_photo/program/34/3.jpg": "40eb",
	"./assets/images/film_photo/program/34/4.jpg": "93e2",
	"./assets/images/film_photo/program/34/5.jpg": "a975",
	"./assets/images/film_photo/program/35/1.jpg": "71c3",
	"./assets/images/film_photo/program/35/2.jpg": "0752",
	"./assets/images/film_photo/program/35/3.jpg": "5cac",
	"./assets/images/film_photo/program/36/1.jpg": "4fe3",
	"./assets/images/film_photo/program/36/2.jpg": "abbb",
	"./assets/images/film_photo/program/36/3.jpg": "d17a",
	"./assets/images/film_photo/program/36/4.jpg": "4c89",
	"./assets/images/film_photo/program/37/1.jpg": "0259",
	"./assets/images/film_photo/program/37/2.jpg": "9bb5",
	"./assets/images/film_photo/program/37/3.jpg": "7ba4",
	"./assets/images/film_photo/program/37/4.jpg": "2834",
	"./assets/images/film_photo/program/37/5.jpg": "dc3d",
	"./assets/images/film_photo/program/37/6.jpg": "da41",
	"./assets/images/film_photo/program/37/7.jpg": "05c4",
	"./assets/images/film_photo/program/38/1.jpg": "f0c6",
	"./assets/images/film_photo/program/38/2.jpg": "28d0",
	"./assets/images/film_photo/program/38/3.jpg": "921a",
	"./assets/images/film_photo/program/38/4.jpg": "3ce1",
	"./assets/images/film_photo/program/38/5.jpg": "37b0",
	"./assets/images/film_photo/program/39/1.jpg": "c6b4",
	"./assets/images/film_photo/program/39/2.jpg": "3f54",
	"./assets/images/film_photo/program/39/3.jpg": "2b22",
	"./assets/images/film_photo/program/39/4.jpg": "fd81",
	"./assets/images/film_photo/program/39/5.jpg": "0a7a",
	"./assets/images/film_photo/program/4/1.jpg": "c1b6",
	"./assets/images/film_photo/program/4/2.jpg": "6e59",
	"./assets/images/film_photo/program/4/3.jpg": "a6be",
	"./assets/images/film_photo/program/4/4.jpg": "7b8c",
	"./assets/images/film_photo/program/4/5.jpg": "9589",
	"./assets/images/film_photo/program/40/1.jpg": "1ffb",
	"./assets/images/film_photo/program/40/2.jpg": "9875",
	"./assets/images/film_photo/program/40/3.jpg": "b5be",
	"./assets/images/film_photo/program/40/4.jpg": "efbf",
	"./assets/images/film_photo/program/40/5.jpg": "526c",
	"./assets/images/film_photo/program/40/6.jpg": "e2e4",
	"./assets/images/film_photo/program/41/1.jpg": "9e1f",
	"./assets/images/film_photo/program/41/2.jpg": "7b06",
	"./assets/images/film_photo/program/41/3.jpg": "7f7e",
	"./assets/images/film_photo/program/41/4.jpg": "55a8",
	"./assets/images/film_photo/program/41/5.jpg": "d269",
	"./assets/images/film_photo/program/41/6.jpg": "71a7",
	"./assets/images/film_photo/program/41/7.jpg": "3216",
	"./assets/images/film_photo/program/5/1.jpg": "6178",
	"./assets/images/film_photo/program/5/2.jpg": "e8d1",
	"./assets/images/film_photo/program/5/3.jpg": "0ef4",
	"./assets/images/film_photo/program/5/4.jpg": "f0f0",
	"./assets/images/film_photo/program/5/5.jpg": "d274",
	"./assets/images/film_photo/program/6/1.jpg": "a027",
	"./assets/images/film_photo/program/6/2.jpg": "da83",
	"./assets/images/film_photo/program/6/3.jpg": "62c0",
	"./assets/images/film_photo/program/6/4.jpg": "53d3",
	"./assets/images/film_photo/program/7/1.jpg": "2901",
	"./assets/images/film_photo/program/7/2.jpg": "c0af",
	"./assets/images/film_photo/program/7/3.jpg": "f962",
	"./assets/images/film_photo/program/7/4.jpg": "2366",
	"./assets/images/film_photo/program/7/5.jpg": "8ad7",
	"./assets/images/film_photo/program/8/1.png": "adac",
	"./assets/images/film_photo/program/8/2.png": "bd57",
	"./assets/images/film_photo/program/8/3.png": "ae37",
	"./assets/images/film_photo/program/9/1.jpg": "05be",
	"./assets/images/film_photo/program/9/2.jpg": "dbc2",
	"./assets/images/film_photo/program/9/3.jpg": "1697",
	"./assets/images/film_photo/program/9/4.jpg": "ca29",
	"./assets/images/film_photo/program/9/5.jpg": "4f5e",
	"./assets/images/film_photo/program/special/1.jpg": "d742",
	"./assets/images/film_photo/program/special/2.jpg": "7e33",
	"./assets/images/film_photo/program/special/3.jpg": "ea13",
	"./assets/images/film_photo/program/special/4.jpg": "ba02",
	"./assets/images/film_photo/program/special/5.jpg": "d769",
	"./assets/images/film_photo/program/special/6.jpg": "42f3",
	"./assets/images/film_photo/program/special/judge.jpeg": "0db4",
	"./assets/images/footer_logo1.png": "6bbc",
	"./assets/images/footer_logo2.png": "6436",
	"./assets/images/footer_logo3.png": "1014",
	"./assets/images/icon_fb.svg": "37a3",
	"./assets/images/icon_line.svg": "37ab",
	"./assets/images/icon_link.svg": "8f9d",
	"./assets/images/icon_play.png": "e2b5",
	"./assets/images/index_banner.png": "4423",
	"./assets/images/index_banner_default.png": "3961",
	"./assets/images/intro_img.jpg": "c2ac",
	"./assets/images/judge/1.png": "0a09",
	"./assets/images/judge/10.png": "b967",
	"./assets/images/judge/11.png": "765b",
	"./assets/images/judge/12.png": "b961",
	"./assets/images/judge/2.png": "a978",
	"./assets/images/judge/3.png": "774c",
	"./assets/images/judge/4.png": "a58e",
	"./assets/images/judge/5.png": "551d",
	"./assets/images/judge/6.png": "2d54",
	"./assets/images/judge/7.png": "cc06",
	"./assets/images/judge/8.png": "8a50",
	"./assets/images/judge/9.png": "070e",
	"./assets/images/judge/MartaKraus.png": "0f2a",
	"./assets/images/judge/MitsuoTahira.png": "3cdc",
	"./assets/images/logo.png": "9d64",
	"./assets/images/logo_blue.png": "f125",
	"./assets/images/mask.png": "b965",
	"./assets/images/sponsor/sponsor_1.png": "6d66",
	"./assets/images/sponsor/sponsor_10.png": "53d6",
	"./assets/images/sponsor/sponsor_11.png": "68f2",
	"./assets/images/sponsor/sponsor_12.png": "a0c8",
	"./assets/images/sponsor/sponsor_13.png": "8ecd",
	"./assets/images/sponsor/sponsor_14.png": "a771",
	"./assets/images/sponsor/sponsor_15.png": "5470",
	"./assets/images/sponsor/sponsor_16.png": "f70a",
	"./assets/images/sponsor/sponsor_17.png": "64ab",
	"./assets/images/sponsor/sponsor_18.png": "82fc",
	"./assets/images/sponsor/sponsor_19.png": "ac0e",
	"./assets/images/sponsor/sponsor_2.png": "6792",
	"./assets/images/sponsor/sponsor_20.png": "6b69",
	"./assets/images/sponsor/sponsor_21.png": "46c0",
	"./assets/images/sponsor/sponsor_22.png": "7375",
	"./assets/images/sponsor/sponsor_23.png": "c498",
	"./assets/images/sponsor/sponsor_24.png": "aa16",
	"./assets/images/sponsor/sponsor_25.png": "5cb9",
	"./assets/images/sponsor/sponsor_3.png": "0406",
	"./assets/images/sponsor/sponsor_4.png": "60f4",
	"./assets/images/sponsor/sponsor_5.png": "4d8d",
	"./assets/images/sponsor/sponsor_6.png": "7d03",
	"./assets/images/sponsor/sponsor_7.png": "daf1",
	"./assets/images/sponsor/sponsor_8.png": "5aff",
	"./assets/images/sponsor/sponsor_9.png": "cc95",
	"./assets/images/sponsor/sponsor_canada.png": "8f82",
	"./assets/images/sponsor/sponsor_french.png": "da99",
	"./assets/images/sponsor/sponsor_germany.png": "c1bd",
	"./assets/images/title_star.png": "97a5",
	"./assets/images/title_underline.png": "2efd",
	"./assets/images/topic_banner.png": "cf2b",
	"./assets/images/topic_list.png": "5089",
	"./assets/images/topic_list_en.png": "c79b",
	"./assets/images/topic_main.png": "531e",
	"./assets/images/topic_top.png": "8dbf",
	"./assets/images/trophy.png": "4b12",
	"./assets/images/video_default.png": "f4b6",
	"./assets/lang/en": "65ff",
	"./assets/lang/en.yaml": "65ff",
	"./assets/lang/i18n": "d434",
	"./assets/lang/i18n.js": "d434",
	"./assets/lang/tw": "cb14",
	"./assets/lang/tw.yaml": "cb14",
	"./assets/particles": "9b1b",
	"./assets/particles.json": "9b1b",
	"./assets/variable.styl": "1afe",
	"./components/Banner": "84af",
	"./components/Banner.vue": "84af",
	"./components/CardFull": "ad6e",
	"./components/CardFull.vue": "ad6e",
	"./components/CardJudge": "5e52",
	"./components/CardJudge.vue": "5e52",
	"./components/CardNews": "2dfb",
	"./components/CardNews.vue": "2dfb",
	"./components/CardVertical": "6c4e",
	"./components/CardVertical.vue": "6c4e",
	"./components/Footer": "fd2d",
	"./components/Footer.vue": "fd2d",
	"./components/Nav": "216c",
	"./components/Nav.vue": "216c",
	"./components/TitleStar": "9d2f",
	"./components/TitleStar.vue": "9d2f",
	"./main": "56d7",
	"./main.js": "56d7",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/api": "2d92",
	"./router/api.js": "2d92",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./views/404": "8cdb",
	"./views/404.vue": "8cdb",
	"./views/Archive": "12b6",
	"./views/Archive.vue": "12b6",
	"./views/Campaign": "10c7",
	"./views/Campaign.vue": "10c7",
	"./views/Components": "2311",
	"./views/Components.vue": "2311",
	"./views/Contact": "b8fa",
	"./views/Contact.vue": "b8fa",
	"./views/FAQ": "0b2e",
	"./views/FAQ.vue": "0b2e",
	"./views/Index": "d504",
	"./views/Index.vue": "d504",
	"./views/Intro": "9d47",
	"./views/Intro.vue": "9d47",
	"./views/ListCard": "03a6",
	"./views/ListCard.vue": "03a6",
	"./views/News": "a2f9",
	"./views/News.vue": "a2f9",
	"./views/Nominee": "4a36",
	"./views/Nominee.vue": "4a36",
	"./views/OTT": "3d83",
	"./views/OTT.vue": "3d83",
	"./views/Rule": "2dd9",
	"./views/Rule.vue": "2dd9",
	"./views/Sponsor": "4005",
	"./views/Sponsor.vue": "4005",
	"./views/Topic": "3213",
	"./views/Topic.vue": "3213",
	"./views/Video": "81a8",
	"./views/Video.vue": "81a8",
	"./views/VideoList": "f0d0",
	"./views/VideoList.vue": "f0d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";